import { render, staticRenderFns } from "./QuotationList.vue?vue&type=template&id=4b815e9d&"
import script from "./QuotationList.vue?vue&type=script&lang=js&"
export * from "./QuotationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports